<template>
    <v-row v-if="!$store.getters.progress" class="pb-offset ma-0">
		<v-col class="pa-0">

            <v-card class="flex pa-0 background-2 round-card">
			    <v-card-title class="pa-3">
    				<p class="pl-2 pl-xl-3">Lista di Carico</p>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">							
                            <v-btn @click="$eventBusUtility.exportCSV(headers, items, 'Lista di Carico')" v-on="on" icon>
                                <v-icon>get_app</v-icon>
                            </v-btn>
                        </template>
                        <span>Download</span>
                    </v-tooltip>                    
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">                        
                            <v-btn v-on="on" @click="printLoadingList()" icon>
                                <v-icon>print</v-icon>
                            </v-btn>
                        </template>
                        <span>Download PDF</span>
                    </v-tooltip>                               
			    </v-card-title>
                <v-divider></v-divider>

                <v-alert
                    text
                    dense
                    type="info"
                    class="ma-4 mb-0"
                    icon="mdi-information-outline">
                    <span class="body-2">
                        Questa schermata consente di visualizzare e gestire i prodotti presenti negli ordini di acquisto
                        che devono essere ricevuti dai fornitori. Puoi filtrare i prodotti e generare report
                        per organizzare il carico della merce in arrivo.
                    </span>
                </v-alert>

                <v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-6">
                    <fields-generator
                        :fieldsset.sync="fieldsset"
                        :model="model"
                        ref="fieldsgenerator"
                    ></fields-generator>

                    <v-row class="mx-0 pt-0">
                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per Fornitore" v-model="model['group_by_suppliers']" value="suppliers"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per data di consegna" v-model="model['group_by_delivery_date']" value="delivery_date"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Dividi per ordine" v-model="model['group_by_purchaseorder']" value="purchaseorder"></v-switch>
                        </v-col>

                        <v-col class="py-0 px-4" cols="3" sm="3" md="6" lg="4">
                            <v-switch color="primary" inset label="Stampa Importi" v-model="model['print_import']" value="print_import"></v-switch>
                        </v-col>

                    </v-row>
			        <v-divider></v-divider>

                    <v-data-table
                        :items="items"
                        :headers="headers"
                        :loading="loading"
                        multi-sort
                        class="background-2 round-card pb-0"
			            :mobile-breakpoint="0"
                        >
                        <template v-slot:item="{item, headers}">
                            <tr class="cursor-pointer">
                                <template v-for="(header, h) in headers">
                                    <td v-if="header.type === 'currency'" :key="h">
                                        {{ item[header.value] | currency(2) }}
                                    </td>
                                    <td v-else-if="header.type == 'date'" :key="h">
                                        {{ item[header.value] | date }}
                                    </td>
                                    <td v-else-if="typeof header.text_value !== 'undefined'" :key="h">
                                        {{ item[header.text_value] }}
                                    </td>
                                    <td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h">
                                        <v-chip v-for="(chip, c) in JSON.parse(item[header.value])" small :key="c">{{ chip }}</v-chip>
                                    </td>
                                    <td v-else :key="h">
                                        {{ header.type}}
                                        {{ item[header.value] }}
                                    </td>
                                </template>
                            </tr>
                        </template>
                        <template v-slot:footer.page-text="{ pageStart, pageStop }">
                            Da {{ pageStart }} a {{ pageStop }} di {{ totalItems }}
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>

    export default {
        name: "loading-list",
    
        data() {
            return {
				items: [],
				loading: false,
                filtered: false,
                headers: [],
                fieldsset: [],
                model: {},
                totalItems: 0
            }
        },

        watch: {
            model: {
                handler() {
                    this.getData()
                },
                deep: true,
                immediate: true
            }
        },

        methods: {

            getData() {
                this.loading = 'warning'
                this.axios.post('purchaseordersloadinglist', this.model).then(response => {
                    this.items = response.data.data
                    this.totalItems = response.data.data.length
                    this.totals = response.data.data.totals
                    this.loading = false

                }, response => {
                    // error callback
                })
            },

            printLoadingList() {
                this.$eventBusUtility.openFile(this.$store, '/purchaseordersloadinglist-print', 'Lista di Carico', 'POST', this.model)
            },
        },
        
        created() {
            this.axios.get('purchaseordersloadinglist-info').then(response => {
                // get body data
                this.fieldsset = response.data.fields
                this.headers = response.data.info.fieldDefs

                this.$store.commit('endProgress')

            }, response => {
                // error callback
            })
        },
    }
</script>
